import React, { useContext } from "react";
import { Button, Checkbox, Flex, Form, Input, Typography } from "antd";
import {
  LockOutlined,
  UserOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import "./login.css";

import { Navigate } from "react-router";
import { AuthContext } from "$context/AuthContextProvider";
const { Title } = Typography;

const Login = () => {
  const authContext = useContext(AuthContext);

  const onFinish = async (values) => {
    try {
      await authContext.login(values);
    } catch (err) {
      console.error(err);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  if (authContext.isAuthenticated) {
    return authContext.isAdmin ? (
      <Navigate to="/agent_home" />
    ) : (
      <Navigate to="/location_home" />
    );
  } else {
    return (
      <div className="container">
        <div className="login_card">
          <Title level={3} style={{ margin: "0 0 24px 0" }}>
            Login
          </Title>
          <Form
            className="login"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              className="input"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please enter your username",
                },
              ]}
            >
              <Input
                size="large"
                prefix={<UserOutlined />}
                placeholder="Username"
              />
            </Form.Item>
            <Form.Item
              className="input"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter your password",
                },
              ]}
            >
              <Input.Password
                size="large"
                prefix={<LockOutlined />}
                type="password"
                placeholder="Password"
                iconRender={(visible) =>
                  visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                }
                visibilityToggle
              />
            </Form.Item>
            <Form.Item>
              <Flex justify="space-between" align="center">
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Remember me</Checkbox>
                </Form.Item>
              </Flex>
            </Form.Item>

            <Form.Item>
              <Button
                className="btn_primary"
                size="large"
                block
                type="primary"
                htmlType="submit"
              >
                Log in
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
};
export default Login;
